<script setup lang="ts">
import type { CustomerCreditTransaction } from '@entities/customer'

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'

defineOptions({
  name: 'CustomerCreditsHistoryTable',
})

defineProps<{
  transactions: CustomerCreditTransaction[]
  loading: boolean
  emptyCell: string
  formatDate: (value: string | null) => string
  formatPrice: (cents: number) => string
  formatAmount: (cents: number) => string
}>()

const COLUMNS = ['Date and time', 'Amount', 'Balance after', 'Source']
</script>

<template>
  <div
    v-if="transactions.length || loading"
    class="customer-credits-history-table"
  >
    <AppTable
      class="rounded-table"
      :loading="loading"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh
            v-for="column in COLUMNS"
            :key="column"
          >
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              {{ column }}
            </AppText>
          </AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="transaction in transactions"
          :key="transaction.id"
        >
          <AppTd class="medium">
            <AppText name="body1">
              {{ formatDate(transaction.created_at) }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body1-medium"
              :color="transaction.value > 0 ? 'emerald-600' : 'red-600'"
            >
              {{ formatAmount(transaction.value) }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText name="body1">
              {{ formatPrice(transaction.balance) }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText name="body1">
              {{ transaction.source || emptyCell }}
            </AppText>
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
  <div
    v-else
    class="customer-credits-history-table__empty"
  >
    <AppText
      name="body1"
      color="slate-500"
    >
      No credit transactions yet.
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./CustomerCreditsHistoryTable.scss" />
